export const SET_AVAILABLE_DEVICES = 'SET_AVAILABLE_DEVICES';
export const SET_DEVICE_SETTINGS = 'SET_DEVICE_SETTINGS';
export const SET_MEDIADEVICE_PERMISSION_STATE = 'SET_MEDIADEVICE_PERMISSION_STATE';
export const SET_ENUMERATEDEVICES_ERROR = 'SET_ENUMERATEDEVICES_ERROR';
